module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xoFY8p/tc-custom/9781667444420.jpg?1680370567591",
      "alt": "This image is the cover for the book Fortaleciendo Los Cimientos"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fortaleciendo Los Cimientos\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("La cuarta novela de la serie PEM. La civilización regresa a la granja y también todos los problemas asociados con ella. Jeb y Sophie tienen sentimientos encontrados sobre cómo manejar los cambios para ellos y para su hija. La familia en su conjunto está dividida. Algunos abrazan el regreso de la tecnología y la comida chatarra, otros la rechazan, mientras que otros intentan elegir opciones. Han sobrevivido a un PEM, el colapso de la civilización y un terremoto catastrófico, ¿podrán sobrevivir a esto? "), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephanie Albright, mislibrosencastellano\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Stephanie Albright creció en Amanda, Ohio. En 1986 se fue a Mississippi a pasar el verano y nunca regresó. Se graduó de la Universidad para Mujeres de Mississippi con un título en Estudios Paralegales y tiene una Maestría en Educación de "), _c('i', [_vm._v("Western Governors University")]), _vm._v(". Le encanta la historia, los viajes y la comida, no necesariamente en ese orden. Las palabras siempre han sido su pasión, ya sea leyendo o escribiendo. Ahora vive en Alabama con un pequeño gallinero y un gato muy enojado, que disfruta estar afuera casi tanto como ella. Además de leer y escribir, le encanta la jardinería, aprender sobre plantas, y tomar café en el porche."), _c('br'), _vm._v(" Es autora de varias novelas publicadas y un cuento."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Babelcube Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0